import { Injectable, Pipe, PipeTransform } from '@angular/core';
import { LocalizedDateTimeFormatKey } from '../types/localization-setting';
import { BaseLocalizedDateTimeFormatPipe } from './base-localized-date-time-format.pipe';

@Injectable({
  providedIn: 'root',
})
@Pipe({
  name: 'localizedDateTimeFormat',
  standalone: true,
})
export class LocalizedDateTimeFormatPipe
  extends BaseLocalizedDateTimeFormatPipe
  implements PipeTransform
{
  protected readonly formatType: LocalizedDateTimeFormatKey = 'dateTimeFormat';
}
